import { Component, OnInit, Input } from '@angular/core';
import { StorageManagerService } from '../../shared/services/index';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { BaseAccordionComponent } from '../base-accordion/base-accordion.component';

@Component({
    selector: 'app-submission-model-clinical-investigation-eu',
    templateUrl: './submission-model-clinical-investigation-eu.component.html',
    styleUrls: ['./submission-model-clinical-investigation-eu.component.css'],
    standalone: false
})
export class SubmissionModelClinicalInvestigationEuComponent extends BaseAccordionComponent implements OnInit {

  constructor (public fb: FormBuilder, public storage: StorageManagerService) {

    super(fb, storage);
   }

  ngOnInit() {
    this.dataScope = this.storage.read('dataScope');
    this.applicableRegulation = this.getApplicableRegulationString();

    this.initializeMainForm();

    this.patchForms();
  }

  initializeMainForm() {

    this.deviceForm = this.fb.group({

      referencesForm: this.fb.array([this.addReferencesForm()]),
      certificateForm: this.fb.array([this.addCertificateForm()])
    });

    // Watch changes on the entire deviceForm
    this.deviceForm.valueChanges.subscribe(data => {
      this.logValidationErrors(this.deviceForm);
    });
  }

  get referencesForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('referencesForm');
  }

  get certificateForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('certificateForm');
  }

  addReferencesForm(): FormGroup {

    return this.fb.group({
      investigationNumber: ['', { validators: [] }],
      applicableCountry: ['', { validators: [] }]
    });
  }

  addCertificateForm(): FormGroup {

    return this.fb.group({
      certType: ['', { validators: [] }],
      certNumber: ['', { validators: [] }],
      certRevisionNumber: ['', { validators: [] }],
      certBody: ['', { validators: [] }],
      certExpDate: ['', { validators: [] }]
    });
  }

  patchForms() {

    this.deviceForm.setControl('referencesForm', this.setReferencesForm());
    this.deviceForm.setControl('certificateForm', this.setCertificateForm());
  }


  setReferencesForm(): FormArray {

    const formArray = new FormArray([]);

    let refs: any;

    refs = this.displayItemData('Clinical Investigation References');

    if (refs && refs.length > 0) {
      refs.forEach((c, i) => {

          formArray.push(

                this.fb.group({
                  investigationNumber: c[(this.getMapInnerPathName('Clinical Investigation Reference Number'))[0]],
                  applicableCountry: c[(this.getMapInnerPathName('Non-EU Applicable Countries'))[0]]
                })
            );
        });
    }

    return formArray;
  }

  setCertificateForm(): FormArray {

    const formArray = new FormArray([]);

    let certificates: any;

    certificates = this.displayItemData('Certificates');

    if (certificates && certificates.length > 0) {
      certificates.forEach((c, i) => {

          formArray.push(

                this.fb.group({
                  certType: c[(this.getMapInnerPathName('Certificate Type'))[0]],
                  certNumber: c[(this.getMapInnerPathName('Certificate Number'))[0]],
                  certRevisionNumber: c[(this.getMapInnerPathName('Certificate Revision Number'))[0]],
                  certBody: c[(this.getMapInnerPathName('Notified Body ID'))[0]],
                  certExpDate: c[(this.getMapInnerPathName('Expiry Date'))[0]],
                })
            );
        });
    }

    return formArray;
  }

  showClinicalInvestigationReferences(): boolean {
    return (this.dataScope || '').toLowerCase() !== 'swissdamed';
  }

}

